import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getObjectives } from '../services/objectivesService';
import { getPlans } from '../services/plansService';
import InterestForm from './modals/InterestForm';
import { useObjectiveSelector } from './pricing/hooks/useObjectiveSelector';
import { Objective } from '@/types/objective';
import { Plan } from '@/types/plan';
import { ObjectiveSection } from './pricing/ObjectiveSection';
import { PlansSection } from './pricing/PlansSection';

export default function Pricing() {
  const navigate = useNavigate();
  const [selectedObjective, setSelectedObjective] = useState('');
  const [selectedObjectiveData, setSelectedObjectiveData] = useState<Objective | null>(null);
  const [showInterestForm, setShowInterestForm] = useState(false);
  const [objectives, setObjectives] = useState<Objective[]>([]);
  const [plans, setPlans] = useState<Plan[]>([]);
  
  const {
    isDropdownOpen,
    needsAttention,
    dropdownRef,
    toggleDropdown,
    highlightDropdown,
    clearHighlight
  } = useObjectiveSelector();

  useEffect(() => {
    async function loadData() {
      try {
        const [objectivesData, plansData] = await Promise.all([
          getObjectives(),
          getPlans()
        ]);
        setObjectives(objectivesData);
        setPlans(plansData);
      } catch (error) {
        console.error('Error loading data:', error);
      }
    }
    loadData();
  }, []);

  useEffect(() => {
    const objective = objectives.find(obj => obj.name === selectedObjective);
    setSelectedObjectiveData(objective || null);
  }, [selectedObjective, objectives]);

  const handleGetStarted = async (planId: string) => {
    if (planId === 'interview') {
      setShowInterestForm(true);
      return;
    }

    try {
      sessionStorage.setItem('selectedObjectiveText', selectedObjective || 'Complete Evaluation');
      sessionStorage.setItem('selectedPlanText', plans.find(p => p.id === planId)?.name || '');
      navigate('/register');
    } catch (error) {
      console.error('Error storing selections:', error);
    }
  };

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ObjectiveSection
          objectives={objectives}
          selectedObjective={selectedObjective}
          onSelect={setSelectedObjective}
          isOpen={isDropdownOpen}
          onToggle={toggleDropdown}
          needsAttention={needsAttention}
          selectedObjectiveData={selectedObjectiveData}
          dropdownRef={dropdownRef}
        />

        <PlansSection
          plans={plans}
          selectedObjective={selectedObjective}
          onGetStarted={handleGetStarted}
        />
      </div>

      <InterestForm 
        isOpen={showInterestForm} 
        onClose={() => setShowInterestForm(false)} 
      />
    </section>
  );
}